import { useTheme } from 'hooks/theme';
import { SVGProps } from 'react';
import { CONFIG_ICON } from './config-icon';

const ExchangeIcon = (props: SVGProps<SVGSVGElement>) => {
  const { theme } = useTheme();
  const config_icon = CONFIG_ICON[theme];

  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      {...props}
    >
      <path
        fill={config_icon.secondary}
        d="M15 15H7c-1.65 0-3-1.35-3-3V7c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3v5c0 1.65-1.35 3-3 3ZM7 6c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H7ZM25 28h-8c-1.65 0-3-1.35-3-3v-5c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3v5c0 1.65-1.35 3-3 3Zm-8-9c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1h-8ZM26.12 10.47 25 11.59V10c0-1.65-1.35-3-3-3h-2v2h2c.55 0 1 .45 1 1v1.59l-1.12-1.12-1.41 1.41 3.54 3.54 3.54-3.54-1.41-1.41h-.02ZM10 23c-.55 0-1-.45-1-1v-1.59l1.12 1.12 1.41-1.41-3.54-3.54-3.54 3.54 1.41 1.41 1.12-1.12V22c0 1.65 1.35 3 3 3h2v-2h-2H10Z"
      />
    </svg>
  );
};
export default ExchangeIcon;
